
import { css } from 'lit';
export default css`
:host{
  --pc-footer-primary-color:var(--primary-eggplant);
  --pc-footer-ancillary-color:var(--neutral-dark-eggplant);

  --bg-transparent-to-primary:linear-gradient(
    to left,
    var(--pc-footer-primary-color) 0%,
    var(--pc-footer-primary-color) 50%,
    transparent 50%,
    transparent 100%
  );

  --bg-transparent-to-ancillary:linear-gradient(
    to left,
    var(--pc-footer-ancillary-color) 0%,
    var(--pc-footer-ancillary-color) 50%,
    transparent 50%,
    transparent 100%
  );

  display:block;
  position:relative;
  z-index:2;
}
  @media print{:host{
    display:none
}
  }

.footer{
  background:var(--pc-footer-primary-color);
  border-top-left-radius:var(--spacing-8);
  overflow:hidden;
}

.primary .section{
  padding-top:var(--spacing-8);
  padding-bottom:var(--spacing-4);
}

::slotted([slot='primary']){
  display:flex;
  flex-direction:column;
  gap:var(--spacing-8);
}

.ancillary .section{
  border-top-left-radius:var(--spacing-8);
  background:var(--pc-footer-ancillary-color);
  padding-top:var(--spacing-8);
  padding-bottom:var(--spacing-8);
}

::slotted([slot='ancillary']){
  display:flex;
  flex-direction:column-reverse;
  gap:var(--spacing-6);
  color:var(--primary-white);
}

@media (min-width: 992px){
  .footer{
    background:none;
    border-top-left-radius:0;
    overflow:initial;
  }

  .primary{
    background:var(--bg-transparent-to-primary);
  }

  .primary .section{
    background:var(--pc-footer-primary-color);
    padding-top:var(--spacing-12);
    padding-bottom:var(--spacing-12);
  }

  .ancillary{
    background:var(--bg-transparent-to-ancillary);
  }

  .ancillary .section{
    border-top-left-radius:0;
  }

  ::slotted([slot='ancillary']){
    flex-direction:column;
    gap:var(--spacing-8);
  }

  .section{
    padding-right:var(--spacing-20);
    padding-left:var(--spacing-20);
  }
}

@media (min-width: 1440px){
  .primary .section{
    border-top-left-radius:var(--spacing-12);
    overflow:hidden;
  }

  .section{
    margin:0 auto;
    padding-right:0;
    max-width:1280px;
  }

  ::slotted([slot='primary']){
    flex-direction:row;
    gap:var(--spacing-20);
  }

  ::slotted([slot='ancillary']){
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
  }
}

@media (min-width: 1536px){
  .section{
    max-width:1440px;
  }
}

@media (min-width: 1760px){
  .section{
    padding-left:0;
    max-width:1600px;
  }
}

@media (min-width: 1920px){
  .section{
    max-width:1760px;
  }
}
`;